// Helpers pour l'éditeur photo (react-image-crop).

const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (error) => reject(error));
    image.setAttribute('crossOrigin', 'anonymous'); // même origine -> pas de taint
    image.src = url;
  });

// Renvoie une data-URL de l'image pivotée de `rotation` degrés (0/90/180/270).
// react-image-crop opère alors sur l'image déjà pivotée (crop simple ensuite).
export async function getRotatedImageSrc(imageSrc, rotation = 0) {
  const norm = ((rotation % 360) + 360) % 360;
  if (norm === 0) return imageSrc;

  const image = await createImage(imageSrc);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) return imageSrc;

  const swap = norm === 90 || norm === 270;
  canvas.width = swap ? image.height : image.width;
  canvas.height = swap ? image.width : image.height;

  ctx.translate(canvas.width / 2, canvas.height / 2);
  ctx.rotate((norm * Math.PI) / 180);
  ctx.drawImage(image, -image.width / 2, -image.height / 2);

  return canvas.toDataURL('image/jpeg', 0.95);
}

// Recadre l'élément <img> affiché selon le crop en pixels AFFICHÉS (react-image-crop),
// en remettant à l'échelle vers la résolution native. Renvoie un Blob JPEG.
export async function getCroppedBlobFromImage(imgEl, pixelCrop) {
  if (!imgEl || !pixelCrop || !pixelCrop.width || !pixelCrop.height) return null;

  const scaleX = imgEl.naturalWidth / imgEl.width;
  const scaleY = imgEl.naturalHeight / imgEl.height;

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) return null;

  canvas.width = Math.max(1, Math.round(pixelCrop.width * scaleX));
  canvas.height = Math.max(1, Math.round(pixelCrop.height * scaleY));

  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(
    imgEl,
    pixelCrop.x * scaleX,
    pixelCrop.y * scaleY,
    pixelCrop.width * scaleX,
    pixelCrop.height * scaleY,
    0,
    0,
    canvas.width,
    canvas.height,
  );

  return new Promise((resolve) => canvas.toBlob((blob) => resolve(blob), 'image/jpeg', 0.92));
}
